/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-03 08:34:34
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { Card } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import PreviewFilter from 'src/components/views/filter-settings/style/preview-filter';
import PreviewMobileButton from 'src/components/views/filter-settings/style/preview-mobile-button';

type Props = {
  selected: Number
};

type ComposedProps = Props & WithI18nProps;

class Preview extends Component<ComposedProps, State> {
  render() {
    const { selected, settingsStyleValues, i18n } = this.props;

    return (
      <div className="previewPanel">
        <Card title={i18n.translate('AdminHTML.FilterSettings.Style.preview_CardTitle')} sectioned>
          {selected === 2 ? (
            <PreviewMobileButton settings={settingsStyleValues} />
          ) : (
            <PreviewFilter settings={settingsStyleValues} />
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const formFilterSettingsValues = getFormValues('FilterSettingsForm')(state);
  const settingsStyleValues = _.pick(formFilterSettingsValues.style, [
    'filterMobileButtonBackgroundColor',
    'filterMobileButtonFontFamily',
    'filterMobileButtonFontSize',
    'filterMobileButtonFontTransform',
    'filterMobileButtonFontWeight',
    'filterMobileButtonTextColor',
    'filterOptionFontFamily',
    'filterOptionFontSize',
    'filterOptionTextColor',
    'filterTitleFontFamily',
    'filterTitleFontSize',
    'filterTitleFontTransform',
    'filterTitleFontWeight',
    'filterTitleTextColor'
  ]);

  return {
    settingsStyleValues
  };
};

export default connect(mapStateToProps)(withI18n()(Preview));
